<svg on:click width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="white" fill-opacity="0.12"/>
<circle cx="20" cy="11.2497" r="2.91667" fill="white"/>
<circle cx="20" cy="19.9997" r="2.91667" fill="white"/>
<circle cx="20" cy="28.7497" r="2.91667" fill="white"/>
</svg>
